import { FC } from "react";

import Stack from "@mui/material/Stack";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { formatTimeWithTimezone, getDateInTimezone } from "@/forms-design-system/FormDate/helper";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Time } from "@/icons/outlined";

interface AntiSnipingInfoProps {
  effectiveEndUtc: string | Date;
  timezone: string | null;
}

export const AntiSnipingInfo: FC<AntiSnipingInfoProps> = ({ effectiveEndUtc, timezone }) => {
  const { t } = useTranslate();
  const { isoLocale } = useLocaleContext();

  const luxonDate = getDateInTimezone(new Date(effectiveEndUtc), timezone);
  const formattedTime = formatTimeWithTimezone(luxonDate, isoLocale);

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <FormIcon size="small" sx={(theme) => ({ color: theme.palette.forms?.text.moderate })}>
        <Time />
      </FormIcon>
      <FormTypography variant="body2" vibe="moderate">
        {t("ticketing", "auctionV2.antiSniping.extendedToCloseAt", { time: formattedTime })}
      </FormTypography>
    </Stack>
  );
};
